export default __webpack_public_path__ + "static/style1.1_Andrey-6ee7a6802b7af02c168c44a86f59f012.wav";